"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Add = function Add() {
  return _react2.default.createElement(
    "g",
    { id: "add" },
    _react2.default.createElement("polygon", {
      id: "Shape",
      points: "500 214.285714 285.714286 214.285714 285.714286 0 214.285714 0 214.285714 214.285714 0 214.285714 0 285.714286 214.285714 285.714286 214.285714 500 285.714286 500 285.714286 285.714286 500 285.714286"
    })
  );
};

exports.default = Add;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Add.js
// module id = 2917
// module chunks = 4